import { OnboardingStatus } from '@qdrant/qdrant-cloud-public-api/iam/v1';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { accountService } from '@/api/services/account';
import { resolveAuthenticatedUser } from '../_authenticated.resolvers';
import { DashboardComponent, DashboardErrorFallback, DashboardNotFoundFallback } from './_dashboard.component';

const listReceivedAccountInvitesQuery = accountService.listReceivedAccountInvitesQuery();

export const Route = createFileRoute('/_authenticated/_dashboard')({
  async beforeLoad({ context }) {
    const user = await resolveAuthenticatedUser(context);
    const { items: accounts } = await context.queryClient.fetchQuery(context.listAccountsQuery);

    /**
     * The reason we have to end up checking for accounts length here is because the
     * onboarding flow auto-creates an account hence just checking
     * for onboarding status alone is not sufficient.
     *
     * TODO:
     * - We should decouple the account creation logic with the Onboarding flow as they
     * should be independent of each other. Once this is done, we can simplify this
     * check to only worry about whether the onboarding flow is completed or not and
     * not check for account length.
     */
    if (accounts.length === 0 && user.onboardingStatus !== OnboardingStatus.COMPLETED) {
      throw redirect({ to: '/onboarding/1', replace: true });
    }
    return { listReceivedAccountInvitesQuery };
  },
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.listReceivedAccountInvitesQuery);
  },
  component: DashboardComponent,
  errorComponent: DashboardErrorFallback,
  notFoundComponent: DashboardNotFoundFallback,
});
